'use client';
import { FC, PropsWithChildren } from 'react';
import { DrawerBody } from '@cat-ecom/pcc-components';

export const SelectEquipmentDrawerBody: FC<PropsWithChildren> = ({
  children
}) => {
  return <DrawerBody>{children}</DrawerBody>;
};
